import { TextField, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative"
  },
  count: {
    position: "absolute",
    right: theme.spacing(1),
    bottom: theme.spacing(1),
    color: theme.palette.text.secondary
  }
}));

function TextFieldWithCount(props) {
  const classes = useStyles();
  const maxLength = props.inputProps?.maxLength;

  return (
    <div className={classes.root}>
      <TextField {...props} />
      {maxLength && (
        <div className={classes.count}>
          {props.value?.length ?? 0}/{maxLength}
        </div>
      )}
    </div>
  );
}

export default TextFieldWithCount;
